export const BOTTOM_SHEET_HEIGHT = {
    AUTO: 'auto',
    HALF: 'half',
    FULL: 'full',
} as const;

export type BottomSheetHeight = (typeof BOTTOM_SHEET_HEIGHT)[keyof typeof BOTTOM_SHEET_HEIGHT];
